import { Box } from '@chatterbug/aaron'
import React from 'react'
import { t } from 'src/lib/i18n-react'
import CEFRLevelExplanation from 'src/pages/GoalSetting/subcomponents/CEFRLevelExplanation/CEFRLevelExplanation'
import GoalForm, {
  Props as GoalFormProps,
} from 'src/pages/GoalSetting/subcomponents/GoalForm/GoalForm'
import { CefrLevelCode, LanguageCode } from 'src/types'
import GoalSettingSkeleton from './GoalSettingSkeleton'

export type Props = {
  cefrCode: CefrLevelCode
  cefrLabel: string
  cefrDescription: string
  languageCode: LanguageCode
  sideNoteData: GoalFormProps['sideNoteData']
  liveLessonWeeklyGoal: number
  selfStudyWeeklyGoal: number
  onSaveGoals: () => unknown
}

const GoalSetting: React.FC<Props> = ({
  cefrCode,
  cefrLabel,
  cefrDescription,
  languageCode,
  liveLessonWeeklyGoal,
  selfStudyWeeklyGoal,
  onSaveGoals,
  sideNoteData,
}) => {
  return (
    <GoalSettingSkeleton
      titleSection={
        <Box as="h1" variant="text.h3">
          {t('Language Goals')}
        </Box>
      }
      goalSection={
        <Box
          p={{ _: '2x', tablet: '4x' }}
          borderRadius="1x"
          boxShadow="raised"
          bg="white100"
        >
          <CEFRLevelExplanation
            levelCode={cefrCode}
            label={cefrLabel}
            description={cefrDescription}
            languageCode={languageCode}
          />
          <GoalForm
            onSaveGoals={onSaveGoals}
            liveLessonGoal={liveLessonWeeklyGoal}
            selfStudyGoal={selfStudyWeeklyGoal}
            goalCefrLevel={cefrCode}
            sideNoteData={sideNoteData}
          />
        </Box>
      }
    />
  )
}

export default GoalSetting
